var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ivu-select-dropdown",class:_vm.className,style:(_vm.styles)},[(_vm.showScroll)?_c('LutticaScrollBar',{ref:"dropScrollBar",attrs:{"width":"388px","height":"200px"},on:{"handle-scroll":_vm.scrollToEnd}},[_vm._t("default")],2):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }